module.exports =
{
	locale: 'zh-Hans-SG',
	long: require('./long.json'),
	short: require('../zh/short.json'),
	narrow: require('../zh/narrow.json')
}